<header class="template-header sticky-header header-two">
  <div class="container-fluid">
    <div class="header-navigation box-shadow-5 header-style   {{
        verificarEstiloPortal()
      }}">
      <div class="header-left">
        <div class="site-logo">
          <a [routerLink]="'/home'" (click)="navigateToSection('home')">
            <div class="figure">
              <img class="img-geia-top image-main" src="../../../../assets/app-assets/images/logo/logo-b-geia.png" />
            </div>
          </a>
        </div>
        <nav class="site-menu menu-gap-left d-none d-xl-block">
          <ul class="primary-menu">
            <li>
              <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-size-menu"
                [routerLink]="'/home'" (click)="navigateToSection('home')">A GÉIA</a>
              <ul class="sub-menu border-radius" style="margin-top: -28% !important; max-width: 161px">
                <li>
                  <a [routerLink]="'/about-geia'" (click)="navigateToSection('about-geia')">Quem Somos</a>
                </li>
                <li>
                  <a href="https://www.geiaresponsabilidade.com.br/" target="_blank" rel="noopener noreferrer"
                    style="justify-content: center;">Responsabilidade
                    Socioambiental</a>
                </li>
              </ul>
            </li>
            <li>
              <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-size-menu">PARA
                VOCÊ</a>
              <ul class="sub-menu border-radius" style="margin-top: -20% !important">
                <li>
                  <a [routerLink]="'/portal/saude'" (click)="navigateToSection('saude')">Planos de Saúde</a>
                </li>

                <li>
                  <a [routerLink]="'/portal/odonto'" (click)="navigateToSection('odonto')">Planos Odontológicos</a>
                </li>
                <li>
                  <a [routerLink]="'/portal/seguro'" (click)="navigateToSection('seguro')">Seguros
                  </a>
                </li>
              </ul>
            </li>
            <li routerLinkActive=" active" [routerLinkActiveOptions]="{exact: true}">
              <a class="font-size-menu">PARA SUA EMPRESA</a>
              <ul class="sub-menu border-radius" style="margin-top: -12% !important">
                <li><a [routerLink]="'/geia-empresa'" (click)="navigateToSection('geia-empresa')">PME (2 a 29 vidas)</a>
                </li>
                <li>
                  <a [routerLink]="'/pme'" (click)="navigateToSection('pme')">PME (29 a 99 vidas)</a>
                </li>
                <li>
                  <a [routerLink]="'/grande-empresa'" (click)="navigateToSection('grande-empresa')">Grandes Empresas
                    (+100 vidas)</a>
                </li>
              </ul>
            </li>

            <li routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">
              <a class="font-size-menu">
                <button type="submit" style="
                    border-radius: 30px;
                    margin-left: -2px;
                    padding: 6px 11px;
                  " class="cursor-pointer template-btn">
                  <i class="ft-unlock"> </i> ÁREA DE LOGIN
                </button></a>
              <ul class="sub-menu border-radius" style="margin-top: -11% !important">
                <li><a [routerLink]="['/cliente']">Espaço Cliente</a></li>
                <li>
                  <a href="https://tetis.geia.com.br/Account/logincorretor">Espaço Corretor</a>
                </li>
                <li>
                  <a href="https://portal.geia.com.br/conta/loginentidade">Espaço Entidade</a>
                </li>
                <li>
                  <a href="https://portal.geia.com.br/conta/loginrh">Espaço RH</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div class="header-right">
        <ul class="extra-icons">
          <li class="d-xl-none">
            <a class="navbar-toggler">
              <span></span>
              <span></span>
              <span></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Start Mobile Panel -->

  <div class="slide-panel mobile-slide-panel">
    <div class="panel-overlay"></div>
    <div class="panel-inner" style="height: 97%; overflow: scroll">
      <nav class="mobile-menu">
        <ul class="primary-menu">
          <li class="mt-1">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-size-menu">A GÉIA</a>
            <ul class="sub-menu border-radius">
              <li>
                <a [routerLink]="'/about-geia'" (click)="navigateToSection('about-geia', 'isMoible')">Quem Somos</a>
              </li>
              <li>
                <a href="https://www.geiaresponsabilidade.com.br/" target="_blank" rel="noopener noreferrer"
                  style="justify-content: center;">Responsabilidade
                  Socioambiental</a>
              </li>

            </ul>
          </li>
          <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-size-menu">PARA VOCÊ</a>
            <ul class="sub-menu border-radius">
              <li>
                <a (click)="navigateToSection('saude')" [routerLink]="'/portal/saude'">Planos de Saúde</a>
              </li>
              <li>
                <a (click)="navigateToSection('odonto')" [routerLink]="'/portal/odonto'">Planos Odontológicos</a>
              </li>
              <li>
                <a (click)="navigateToSection('seguro')" [routerLink]="'/portal/seguro'">Seguros
                </a>
              </li>
            </ul>
          </li>

          <li routerLinkActive=" active" [routerLinkActiveOptions]="{exact: true}">
            <a class="font-size-menu">PARA SUA EMPRESA</a>
            <ul class="sub-menu border-radius">
              <li>
                <a [routerLink]="'/geia-empresa'" (click)="navigateToSection('geia-empresa', 'isMoible')">PME (2 a 29
                  vidas)</a>
              </li>
              <li>
                <a [routerLink]="'/pme'" (click)="navigateToSection('pme', 'isMoible')">PME (29 a 99 vidas)</a>
              </li>
              <li>
                <a [routerLink]="'/grande-empresa'" (click)="navigateToSection('grande-empresa', 'isMoible')">Grandes
                  Empresa(+100 vidas)</a>
              </li>
              <span></span>
              <span></span>
            </ul>
          </li>
          <li>
            <a class="font-size-menu">
              <button type="submit" style="
                  border-radius: 30px;
                  margin-left: -2px;
                  padding: 6px 11px;
                " class="cursor-pointer template-btn">
                <i class="ft-unlock"> </i> ÁREA DE LOGIN
              </button></a>
            <ul class="sub-menu border-radius">
              <li><a [routerLink]="['/cliente']">Espaço Cliente</a></li>
              <li>
                <a href="https://tetis.geia.com.br/Account/logincorretor">Espaço Corretor</a>
              </li>
              <li>
                <a href="https://portal.geia.com.br/conta/loginentidade">Espaço Entidade</a>
              </li>
              <li>
                <a href="https://portal.geia.com.br/conta/loginrh">Espaço RH</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <a class="panel-close">
        <i class="fa fa-times"></i>
      </a>
      <div></div>
    </div>
  </div>
  <!-- Start Mobile Panel -->
  <ng-template #template>
    <div class="modal-header">
      <h5 class="modal-title">Simulação</h5>
      <button (click)="decline()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="fa fa-times"></i></span>
      </button>
    </div>
    <div class="modal-body text-center">
      <iframe [src]="urlIframe" style="border: 0px #ffffff none" name="myiFrame" scrolling="yes" frameborder="1"
        marginheight="0px" marginwidth="0px" height="500" width="100%"></iframe>
    </div>
    <div class="modal-footer"></div>
  </ng-template>
</header>